<div class="help-interstitial">
  <div class="grid margin-top-xxsmall">
    <div class="cell cell-small-col-span-6 cell-medium-col-span-6 cell-medium-col-start-2 cell-large-col-span-8 cell-large-col-start-3">
      <div class="text-center">
        <div class="flex flex-justify-center margin-top-xxlarge margin-bottom-xxlarge">
          <div class="partner-logo"></div>
        </div>
        <div>
          <h1 class="margin-bottom-medium" *ngIf="data?.heading">{{ data.heading }}</h1>
          <span class="flex-grow" *ngIf="data?.subtext">{{ data.subtext }}</span>
        </div>
        <img *ngIf="data.settings?.icon" src="{{ data.settings.icon }}" height="50" class="margin-top-xmedium margin-bottom-xmedium"/>
      </div>
    </div>
  </div>
</div>
